import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuthService, SessionCoordinatorService } from '@presencelearning/auth';
import { SpinnerComponent } from '@presencelearning/ui/spinner';

/** Frameless page for a fresh logout. A stale flag never reaches this route. */
@Component({
  selector: 'app-logged-out',
  imports: [SpinnerComponent, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './logged-out.component.html',
})
export class LoggedOutComponent {
  private readonly auth = inject(AuthService);
  private readonly coordinator = inject(SessionCoordinatorService);

  returnToLogin(): void {
    this.coordinator.clearLoggedOut();
    void this.auth.login();
  }
}
